
namespace Gamification.Gamification {
    export class ChecklistNodiColumns {
        static columnsKey = 'Gamification.ChecklistNodi';
    }
}